import { gql } from 'graphql-request'

export namespace HomeIssueQueries {
  export const HOME_ISSUE_SUMMARY = gql`
    fragment HomeIssueSummary on HomeIssue {
      id
      homeLocationId
      homeLocation
      type
      createdAt
      notes
      homeInventoryItemId
      homeInventoryItem {
        name
      }
      resolvedAt
      attachments {
        ...AttachmentDetails
      }
    }
  `
}
